import { createSelector } from 'reselect';
import { RootState } from '../reducers';

export const selectUser = (state: RootState) => state.user;

const selectUserState = selectUser;

export const selectUserPersonalInfo = createSelector([selectUserState], user => user.personalInfo);

export const selectUserRoles = createSelector([selectUserState], user => user.roles || []);

export const selectUserEmail = createSelector([selectUserPersonalInfo], personalInfo => personalInfo?.email);

export const selectUserSub = createSelector([selectUserPersonalInfo], personalInfo => personalInfo?.sub);

export const selectUserName = createSelector([selectUserPersonalInfo], personalInfo => personalInfo?.name);
